import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../../components/tables/ReportsTable';

const UserwiseLedger = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const transactionTypes = ['Credit', 'Debit', 'Commission', 'Refund', 'Top-Up'];
    const descriptions = [
      'Recharge Transaction',
      'Bill Payment',
      'Wallet Top-Up',
      'Commission Earned',
      'Refund Processed',
      'Money Transfer',
      'AEPS Transaction'
    ];
    
    return Array.from({ length: count }, (_, i) => {
      const debit = Math.random() > 0.5 ? (Math.random() * 5000 + 100).toFixed(2) : '0.00';
      const credit = debit === '0.00' ? (Math.random() * 5000 + 100).toFixed(2) : '0.00';
      
      return {
        id: `LED${String(i + 1).padStart(6, '0')}`,
        date: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
          .toISOString().split('T')[0],
        userId: `USER${String(Math.floor(Math.random() * 500) + 1).padStart(4, '0')}`,
        userName: `User ${Math.floor(Math.random() * 500) + 1}`,
        type: transactionTypes[Math.floor(Math.random() * transactionTypes.length)],
        description: descriptions[Math.floor(Math.random() * descriptions.length)],
        debit: debit,
        credit: credit,
        balance: (Math.random() * 10000 + 1000).toFixed(2),
        transactionId: `TXN${String(Math.floor(Math.random() * 10000) + 1).padStart(6, '0')}`
      };
    });
  };

  const [data] = useState(generateSampleData(80));

  // Column definitions
  const columns = [
    { key: 'id', label: 'Ledger ID' },
    { key: 'date', label: 'Date' },
    { key: 'userId', label: 'User ID' },
    { key: 'userName', label: 'User Name' },
    { key: 'type', label: 'Type' },
    { key: 'description', label: 'Description' },
    { key: 'debit', label: 'Debit' },
    { key: 'credit', label: 'Credit' },
    { key: 'balance', label: 'Balance' },
    { key: 'transactionId', label: 'Transaction ID' }
  ];

  return (
    <Container fluid className="">
      <ReportsTable
        data={data}
        reportType="Userwise_Ledger"
        columns={columns}
        title="Userwise Ledger"
      />
    </Container>
  );
};

export default UserwiseLedger;

